<script>
import { emojis } from './../../../../../helpers/index.js';
import { _ } from 'svelte-i18n';
import { createEventDispatcher, onMount } from 'svelte';
import { api } from '../../../../../helpers';
import { changeToken } from '../../../../../Api';
import { currentReplyCommentId } from '../ReplyInput/store';
import { addToast } from '../../../Toasts/store';

import ModalForSortListAndSmile from '../ModalForComments/ModalForSortListAndSmile.svelte';
import CommentImages from '../CommentImages/CommentImages.svelte';

const dispatch = createEventDispatcher();

export let inputRef;
export let id_publicate;

let text = '';
let isLoading = false;
let files = [];

async function postMessage( body ) {
  const response = await api('/api/v1/comment/create/', 'POST', body);
  
  if (!response.ok) {
    changeToken(response.status);
  } else {
    const data = await response.json();
    dispatch('update', { data });
  }
  
  text = '';
  isLoading = false;
}

const createMessage = () => {
  if (!text && !Array.from(files).length) {
    return;
  }

  isLoading = true;

  const data = new FormData();

  data.append('publication', id_publicate);
  
  if ($currentReplyCommentId) {
    data.append('parent', $currentReplyCommentId);
  } 

  if (Array.from(files).length) {
    Array.from(files).forEach((file) => {
      data.append('images', file);
    });
  }

  if (text) {
    data.append('text', text.replace(/\n/g, '<br/>'));
  }
  
  postMessage(data);

  inputRef.style.height = '35px';
  showEmoji = false;
  files = [];
};

const deleteImage = (index) => {
  const fileBuffer = new DataTransfer();

  Array.from(files).forEach((file, i) => {
    if (index !== i) {
      fileBuffer.items.add(file);
    }
  });
  
  files = fileBuffer.files;
}

//вся логика по emoji
let showEmoji = false;

const addAmoji = (e)=> {
  text += e.target.textContent;
};

const keyUpHandler = (e) => {
  if (!text) {
    return;
  }

  if (e.key === 'Enter' && e.ctrlKey) {
    createMessage();
    showEmoji = false; 
  }
}

const checkCountFiles = () => {
  if (files.length > 5) {
    files = [];

    addToast($_('maxFilesWarning'));
  }
}

onMount(() => {
  inputRef.style.height = '35px';
})

</script>

<div class='main'>
  <!-- модальное окно emoji -->
  {#if showEmoji}
    <ModalForSortListAndSmile on:hide-popup={() => showEmoji = false}>
      <div class='emoji-cont'>
        <div class='close_emoji' on:click={()=> showEmoji = false}>
          <i class="icon-cross" />
        </div>

        {#each emojis as emoji}
          <span class='emo' on:click={addAmoji}>{emoji}</span>
        {/each}
      </div>
    </ModalForSortListAndSmile>
  {/if}

  <!-- кнопки картинки и смайла -->
  <div class='main_icon'>
    <div class='icons text-grey'>
      <input
        bind:files
        id="input__file"
        multiple
        accept='image/*'
        type="file"
        style={'display:none'}
        on:change={checkCountFiles}
      />
      <label for='input__file' class='input__file-button' >
        <span class='input__file-icon-wrapper'>
          <i class='icon-image'></i>
        </span>
      </label>
    </div>

    <i class="icon-smile text-grey" on:click|stopPropagation={()=> showEmoji = true} />
  </div>

  <!-- поле ввода -->
  <div class="flex items-center">
    <div class='cont'>
      <textarea
        on:input={() => {
          inputRef.style.height = "5px";
          inputRef.style.height = (inputRef.scrollHeight) + "px";
        }}
        maxlength='4000' 
        bind:this={inputRef} 
        bind:value={text} 
        placeholder={$_('Comment')}
        on:keydown={keyUpHandler}
        on:focus={() => currentReplyCommentId.set(null)}
      />
    </div> 
    <div>
      <button 
        class='button__send' 
        disabled={isLoading}
        on:click={createMessage}
      >
        <i class="icon-send" />
      </button>
    </div>
  </div>

  <CommentImages 
    {files} 
    on:delete={(event) => deleteImage(event.detail.index)} 
  />
</div>

<style lang="scss">
  .icon-cross {
    color: #BDBFC4;
    font-size: 12px;
  }

  .icon-smile {
    font-size: 18px;
  }
  
  @keyframes -global-rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  } 

.main{
  margin-top: 7px;
  margin-bottom: 34px;
  display: flex;
  flex-direction: column;

  @media (max-width: 576px) {
    margin-bottom: 24px;
  }
}

.icons{
  width:30px;
}

.input__file-button {
  cursor: pointer;
}

.cont {
	position: relative;
  width: 100%;
}
	
 textarea {
	padding: 8px;
	border: 1px solid #E0E8F6;
	line-height: normal;
  margin: 0;
  background: #E0E8F6;
  border-radius: 4px;
  box-sizing: border-box;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  overflow-y: scroll;
  -moz-user-select: text;
  -webkit-user-select: text;
  -ms-user-select: text;
} 

textarea::-webkit-scrollbar {
  display: none;
}
	
textarea {
  max-height: 100px;
	width: 100%;
	height: 100%;
	resize: none;
  font-size: 14px;
  line-height: 18px;
  box-sizing: border-box;
}
textarea:focus{
  font-size: 14px;
  line-height: 18px;
}

::placeholder {
  font-size: 14px;
  line-height: 18px;
  color: #30333D;
}

/* кнопка для отправки */
.button__send {
  margin: 0 0px 5px 15px;
  border-radius: 50%;
  border: none;
  background: #2B50ED;
  cursor: pointer;
  width: 34px;
  height: 34px;
  position: relative;
}

.icon-send {
  font-size: 14px;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

  /* все для отображения emoji */
.main_icon{
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items:center;
}

.emoji-cont{
  position:absolute;
  z-index: 999;
  height: 100px;
  width: 200px;
  margin-left: 80px;
  margin-top: -100px;
  overflow: auto;
  padding: 10px 0 10px 10px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(48, 51, 61, 0.26);
  background:white;
  animation: ani 0.2s forwards;
}
@keyframes ani {
  0% {transform: translateY(10%);}
  100% {transform: translateY(0);}
}

.emo{
  margin: 5px; 
 cursor: pointer;
}

.close_emoji{
  padding-left: 161px;
  cursor: pointer;
  padding-bottom: 5px;
}
</style>
